import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/assetCategories'
import Component from 'components/AssetCategories'

export default createListViewContainer({ actions, selectors: selectors.assetCategories })(Component)
